import {ready} from "./utils/ready"
import starAnimation from "./utils/star-animation";
import swiper from "./utils/swiper";

ready(() => {
    starAnimation()
    swiper()
})